import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import {
  browserName,
  browserVersion,
  mobileModel,
  mobileVendor,
  osName,
  osVersion,
} from "react-device-detect";
import ApiController from "./controller/ApiController";
import AsyncLocalStorage from "./utils/AsyncLocalStorage";
import { logToServer } from "./utils/util";

const deviceInfo = require("../package.json");
const sDeviceInfo = `${osVersion}|${osName}|${browserName}|${browserVersion}|${mobileVendor}|${mobileModel}|${deviceInfo.name}|${deviceInfo.version}`;
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC228iz5afaWWk53quzaBlmN3YWsLw7UBw",
  authDomain: "knockknock-150b6.firebaseapp.com",
  projectId: "knockknock-150b6",
  storageBucket: "knockknock-150b6.appspot.com",
  messagingSenderId: "930458851128",
  appId: "1:930458851128:web:7eca1f5c374a12793b13cd",
  measurementId: "G-D23435VXBW",
};
// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const messaging = () => {
  return getMessaging(firebaseApp);
};

const userAgent = navigator.userAgent;

export const requestNotificationPermission = () => {
  logToServer({
    permission: "Requesting User Permission......",
    sDeviceInfo: sDeviceInfo,
  });
  // console.log("Requesting User Permission......");
  try {
    Notification.requestPermission().then((permission) => {
      logToServer({ permission: permission, sDeviceInfo: sDeviceInfo });
      // console.log('REACT_APP_FIREBASE_KEY>',process.env.REACT_APP_FIREBASE_KEY);
      if (permission === "granted") {
        navigator.serviceWorker
          .register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`)
          .then(async (registration) => {
            return getToken(messaging(), {
              serviceWorkerRegistration: registration,
              vapidKey: process.env.REACT_APP_FIREBASE_KEY,
            })
              .then(async (currentToken) => {
                if (currentToken) {
                  AsyncLocalStorage.setItem(
                    "firebaseToken",
                    currentToken.toString()
                  );
                  ApiController.user.setWebFirebaseToken(currentToken);
                } else {
                  console.log("Failed to generate the app registration token.");
                }
              })
              .catch((err) => {
                console.log(
                  "An error occurred when requesting to receive the token.",
                  err
                );
              });
          });
      } else {
        console.log("User Permission Denied.", permission);
      }
    });
  } catch (e) {
    console.error("not supported FCM");
  }
};

/*
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('onMessageListener vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv', payload);
      resolve(payload);
    });
  });
  */
